import PropTypes from 'prop-types';

// material-ui
import Box from '@mui/material/Box';

// project imports
import logoWhite from 'assets/images/weightrax-logo-white.png';
import logoBlue from 'assets/images/weightrax-logo-blue.png';

// ==============================|| WEIGHTRAX LOGO ||============================== //
//
// Sidebar is WHITE (Path B Figma, locked 2026-05-09), so the blue logo is the
// default for normal callers. Pass `dark` when rendering on a dark surface to
// switch to the white mark. In the dark colour scheme the blue mark gets a
// semi-transparent white backing so it stays legible on the navy surfaces.

export default function Logo({ dark = false }) {
  return (
    <Box
      component="img"
      src={dark ? logoWhite : logoBlue}
      alt="Weightrax"
      sx={(theme) => ({
        height: 48,
        width: 'auto',
        display: 'block',
        ...(!dark &&
          theme.applyStyles('dark', {
            bgcolor: 'rgba(255, 255, 255, 0.85)',
            borderRadius: 1,
            px: 1.25,
            py: 0.5
          }))
      })}
    />
  );
}

Logo.propTypes = { dark: PropTypes.bool };
